import { styled } from '@withjoy/joykit';

export const ErrorMessage = styled.div`
  color: ${props => props.theme.colors.negative6};
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
  font-size: 14px;
`;
